import { render, staticRenderFns } from "./CrearAnamnesis.vue?vue&type=template&id=f26c2e5c"
import script from "./CrearAnamnesis.vue?vue&type=script&lang=js"
export * from "./CrearAnamnesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports